<div class="filter-row" style="display: flex; align-items: center; gap: 8px">
  <div
    class="gpd-selectable filter-button"
    #filterIcon
    (click)="!isHiding ? toggleMenu() : null"
  >
    <app-svg-icon
      icon="filter"
      [size]="24"
      [strokeWidth]="1"
      color="var(--color-primary)"
      class="filter-icon"
      *ngIf="!isFilterApplied"
    >
    </app-svg-icon>

    <span *ngIf="isFilterApplied" class="filter-applied-icon">
      <app-svg-icon
        icon="filter"
        [size]="18"
        [strokeWidth]="1"
        color="#fff"
        class="filter-icon"
      ></app-svg-icon>
    </span>
  </div>

  <span
    *ngIf="isFilterApplied"
    class="reset-filters-text"
    style="cursor: pointer; color: var(--color-primary); font-weight: 700"
    (click)="resetAllFilters()"
    i18n="@@reset"
  >
    Reset
  </span>
</div>

<dx-popup
  [(visible)]="showFilterMenu"
  [shading]="false"
  [hideOnOutsideClick]="true"
  [showTitle]="false"
  [showCloseButton]="false"
  width="fit-content"
  height="fit-content"
  [wrapperAttr]="{ class: 'gpd-popup' }"
  (onHiding)="isHiding = true"
  (onHidden)="isHiding = false"
>
  <dxo-position
    at="bottom left"
    my="top left"
    [of]="filterIcon"
    collision="fit"
    [offset]="{ x: 0, y: 8 }"
  >
  </dxo-position>

  <div class="filter-content" *ngIf="unsavedFilterState">
    <div class="filter-section">
      <span class="filter-title" i18n="@@filter">Filter</span>
    </div>
    <div class="filter-section">
      <div class="input-header">
        <span class="filter-label" i18n="@@period">Period</span>
        <span class="filter-reset" (click)="resetPeriodFilter()" i18n="@@reset"
          >Reset</span
        >
      </div>
      <div class="input-container">
        <gpd-datebox
          [(value)]="unsavedFilterState.period.from"
          i18n-label="@@from"
          label="From"
          labelMode="outside"
        ></gpd-datebox>
        <gpd-datebox
          [(value)]="unsavedFilterState.period.to"
          label="To"
          i18n-label="@@to"
          labelMode="outside"
        ></gpd-datebox>
      </div>
    </div>
    <div class="filter-section">
      <div class="input-header">
        <span class="filter-label" i18n="@@tags">Tags</span>
        <span class="filter-reset" (click)="resetTagsFilter()" i18n="@@reset"
          >Reset</span
        >
      </div>
      <div class="input-container">
        <dx-tag-box
          [dataSource]="sparkTags"
          [(value)]="unsavedFilterState.tags"
          displayExpr="name"
          valueExpr="id"
          class="gpd-input"
          [showSelectionControls]="true"
          tagTemplate="tagTemplate"
          itemTemplate="itemTemplate"
        >
          <div *dxTemplate="let data of 'tagTemplate'">
            <span
              class="spark-tag"
              [style.backgroundColor]="data.color?.background"
              [style.color]="data.color?.text"
              [style.borderColor]="data.color?.border"
              >{{ data.name }}</span
            >
          </div>

          <div *dxTemplate="let data of 'itemTemplate'">
            <span
              class="spark-tag"
              [style.backgroundColor]="data.color?.background"
              [style.color]="data.color?.text"
              [style.borderColor]="data.color?.border"
              >{{ data.name }}</span
            >
          </div>
        </dx-tag-box>
      </div>
    </div>
    <div class="filter-section">
      <div class="input-header">
        <span class="filter-label" i18n="@@person">Person</span>
        <span class="filter-reset" (click)="resetPersonFilter()" i18n="@@reset"
          >Reset</span
        >
      </div>
      <div class="input-container">
        <dx-select-box
          [dataSource]="users"
          [(value)]="unsavedFilterState.person"
          displayExpr="displayName"
          valueExpr="emailAddress"
          class="gpd-input"
          itemTemplate="personTemplate"
        >
          <div *dxTemplate="let data of 'personTemplate'">
            <div class="person-item">
              <app-user-avatar
                [userEmail]="data.emailAddress"
                [size]="24"
                class="person-avatar"
              ></app-user-avatar>
              <span class="person-name">{{ data.displayName }}</span>
            </div>
          </div>
        </dx-select-box>
      </div>
    </div>
    <div class="filter-section">
      <div class="input-container">
        <dx-check-box
          [(value)]="unsavedFilterState.unread"
          class="gpd-input"
          i18n-text="@@showOnlyUnreadMessages"
          text="Show only unread messages"
        >
        </dx-check-box>
      </div>
    </div>
    <div class="filter-section">
      <div class="input-container">
        <app-gpd-button
          i18n-text="@@resetAll"
          text="Reset all"
          type="secondary"
          (onClick)="resetAllFilters()"
        ></app-gpd-button>
        <app-gpd-button
          i18n-text="@@apply"
          text="Apply"
          icon="tick"
          (onClick)="applyFilters()"
        ></app-gpd-button>
      </div>
    </div>
  </div>
</dx-popup>
